<template>
  <div class="screen-loading">
    <div class="screen-loading__container">
      <img :src="logo" alt="Gator" class="screen-loading__container__img" />
      <div class="screen-loading__container__label">
        {{ $t('screen.loading.label') }}
      </div>
      <ui-loader class="screen-loading__container__loader" stroke="#A4B0C8" />
    </div>
  </div>
</template>

<script>
import UiLoader from '@/components/UI/Loader.vue'

export default {
  name: 'ScreenLoading',
  components: {
    UiLoader,
  },
  computed: {
    logo() {
      return process.env.LOGO_URL_PROD || require('@/assets/img/logo_gtr_watch.svg')
    },
  },
}
</script>

<style lang="scss">
.screen-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $gutter-sm;
  width: 100%;
  height: 100%;
  text-align: center;

  @media (min-width: $screen-sm) {
    padding: $gutter-md;
  }

  &__container {
    margin: auto;

    &__img {
      width: 300px;
    }

    &__label {
      margin-top: $spacing-md;
      color: $generic-color-text;
      font-size: 1rem;
      font-weight: bold;
    }

    &__loader {
      margin-top: $spacing-md;
    }
  }
}
</style>
